/* Knowledge categories */
export const GET_LEVELS = "GET_LEVELS"
export const GET_LEVELS_SUCCESS = "GET_LEVELS_SUCCESS"
export const API_ERROR = "API_ERROR"
